export const navigation = [
  {
    text: 'Dashboard',
    icon: 'chart',
    path: '/analytics-dashboard'
  },
  {
    text: 'Opdrachten',
    icon: 'textdocument',
    path: '/work-tasks'
  },
  {
    text: 'Planning',
    icon: 'event',
    path: '/worktasks-planning'
    },
    {
        text: 'Onderhoud',
        icon: 'product',
        path: '',
        items: [
            {
                text: 'Planning',
                path: '/maintenance-planning'
            },
            {
                text: 'Overzicht',
                path: '/maintenance',
            },
            {
                text: 'Contracttypes',
                path: '/contract-type-management',
            },
        ],
    },
  {
    text: 'Relaties',
    icon: 'user',
    path: '/crm-contact-list'
  },
  {
    text: 'Activiteiten',
    icon: 'runner',
    path: '/activity-management',
  },
  {
    text: 'Medewerkers',
    icon: 'group',
    path: '/employees'
  },
  {
    text: 'E-mail Templates',
    icon: 'email',
    path: '/email-designer'
  },
  {
    text: 'Instellingen',
    icon: 'preferences',
    path: '/company-settings'
  },
];

export const getNavigation = (isHostAdmin?: boolean) => {
  const items = [...navigation];
  if (isHostAdmin) {
    items.push({
      text: 'Tenant Beheer',
      icon: 'preferences',
      path: '/tenant-admin'
    });
  }
  return items;
};
